import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import DateRangePicker from '../ui/DateRangePicker'
import { updateUrlFilters, useUrlFilters } from '../../utils/urlFilters'
import { isValidIsoDate } from '../../utils/dateHelpers'

const START_DATE_KEY = 'start_date'
const END_DATE_KEY = 'end_date'

const HeaderDateRangePicker = ({ maxDate, minDate, reloadOnChange, showPresets }) => {
  const filters = useUrlFilters()
  const filterStart = filters[START_DATE_KEY]
  const filterEnd = filters[END_DATE_KEY]
  const startValid = isValidIsoDate(filterStart)
  const endValid = isValidIsoDate(filterEnd)
  const rangeInverted = startValid && endValid && filterStart > filterEnd
  const startDate = startValid && !rangeInverted ? filterStart : minDate
  const endDate = endValid && !rangeInverted ? filterEnd : maxDate

  useEffect(() => {
    const invalid = {}
    if (filterStart && (!startValid || rangeInverted))
      invalid[START_DATE_KEY] = null
    if (filterEnd && (!endValid || rangeInverted))
      invalid[END_DATE_KEY] = null
    if (Object.keys(invalid).length > 0)
      updateUrlFilters(invalid)
  }, [filterStart, filterEnd, startValid, endValid, rangeInverted])

  const handleChange = useCallback(range => {
    const changed = updateUrlFilters({ [START_DATE_KEY]: range.from, [END_DATE_KEY]: range.to })
    if (reloadOnChange && changed)
      window.location.reload()
  }, [reloadOnChange])

  return (
    <DateRangePicker
      endDate={endDate}
      maxDate={maxDate}
      minDate={minDate}
      showPresets={showPresets}
      startDate={startDate}
      onChange={handleChange}
    />
  )
}

HeaderDateRangePicker.propTypes = {
  maxDate: PropTypes.string.isRequired,
  minDate: PropTypes.string.isRequired,
  reloadOnChange: PropTypes.bool,
  showPresets: PropTypes.bool
}

HeaderDateRangePicker.defaultProps = {
  reloadOnChange: false,
  showPresets: false
}

export default HeaderDateRangePicker
